export default "__VITE_ASSET__f1YPQhnI__"